import type { FeedbackAnswerQuestionSingle } from '@repo/types/questions/QuestionSingle';

import { getCorrectTypeColor } from '@repo/lib/quiz/getCorrectTypeColor';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import {
  QuestionMarkedCorrectToggleField,
  QuestionMarkedExplanationField,
  QuestionMarkedFormActions,
  QuestionMarkedPointsField,
  QuestionMarkedResponseCard,
  QuestionMarkedResponseContent,
  QuestionMarkedResponseHeader,
} from '@/components/features/quiz/question/question-marked/QuestionMarked';
import { Form, FormField } from '@/components/ui/form';
import { Markdown } from '@/components/ui/markdown';

import type { QuestionMarkedSingleFormProps } from '.';

export function QuestionMarkedSingleForm(questionMarkedSingleFormProps: QuestionMarkedSingleFormProps) {
  const { marked, isOpen, onClose, onSubmit: _onSubmit, userAnswerContent, maxPoints } = questionMarkedSingleFormProps;
  const form = useForm<FeedbackAnswerQuestionSingle>({
    defaultValues: {
      points: 0,
      correct: false,
      explanation: null,
    },
  });

  const onSubmit = (data: FeedbackAnswerQuestionSingle) => {
    _onSubmit?.(data);
    onClose();
  };

  useEffect(() => {
    if (isOpen && marked) {
      form.reset(marked);
    }
  }, [isOpen, marked]);

  return (
    <Form {...form}>
      <form className={'flex w-full flex-col gap-3 p-3'} onSubmit={form.handleSubmit(onSubmit)} noValidate>
        <QuestionMarkedResponseCard>
          <QuestionMarkedResponseHeader>
            <QuestionMarkedCorrectToggleField control={form.control} name="correct" />
            <QuestionMarkedPointsField control={form.control} name="points" maxPoints={maxPoints} />
          </QuestionMarkedResponseHeader>

          <QuestionMarkedResponseContent>
            <FormField
              name="correct"
              control={form.control}
              render={({ field: { value } }) => (
                <Markdown content={userAnswerContent ?? ''} textClassName={getCorrectTypeColor(value)} imageClassName="max-h-68 rounded-sm" videoClassName="max-h-68 rounded-sm" />
              )}
            />
          </QuestionMarkedResponseContent>

          <QuestionMarkedExplanationField control={form.control} name="explanation" />
        </QuestionMarkedResponseCard>
        <QuestionMarkedFormActions onClose={onClose} />
      </form>
    </Form>
  );
}
